import React from 'react'
import styled from 'styled-components'

type Props = {
  /**
   * Percent filled of the the bar. A number between 0 - 1.
   * */
  percent: number
  /**
   * Color of the bar. Defaults to palette color.
   */
  color?: string
}

const RdnaProgressBar = ({ percent, color }: Props) => {
  return (
    <Container>
      <Bar data-testid="progress-bar" $percent={percent * 100} $color={color} />
    </Container>
  )
}

export default RdnaProgressBar

const Container = styled.div`
  display: flex;
  width: 100%;
  ${({ theme: { spacing, palette } }) => `
    height: ${spacing}px;
    border-radius: ${spacing}px;
    background-color: ${palette.primary.light};
  `};
`

type StyleProps = {
  $percent: number
  $color?: string
}

const Bar = styled.div<StyleProps>`
  display: flex;
  ${({ theme: { spacing, palette, transitions }, $percent, $color }) => `
    width: ${$percent}%;
    border-radius: ${spacing}px;
    transition-property: width;
    transition-duration: ${transitions.duration.standard}ms;
    transition-timing-function: ${transitions.easing.easeInOut};
    background-color: ${$color || palette.primary.main};
  `};
`
